import React, { useEffect, useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select from "react-select";
import "./LiveScorecardFilters.css";

const GET_PLAYERS = graphql`
  query LiveScorecardFiltersPlayersQuery($eventId: ID!) {
    playersForLiveRound(eventId: $eventId) {
      id
      fullName
    }

    myPlayersForLiveRound(eventId: $eventId) {
      id
      fullName
    }

    exportedLineupSetsForPgaEvent(pgaEventId: $eventId) {
      id
      greenMachineSession {
        slate {
          suffix
        }
      }

      buildNum
    }
  }
`;

export default function LiveScorecardFilters(props) {
  const data = useLazyLoadQuery(
    GET_PLAYERS,
    {
      eventId: props.selectedEventID,
    },
    { fetchPolicy: "network-only", fetchKey: props.reloads }
  );

  const [importSelect, setImportSelect] = useState({});
  const [sessionImportOptions, setSessionImportOptions] = useState([]);

  const myPlayerIds = props.myPlayers.map((player) => player.value);

  useEffect(() => {
    props.updateMyPlayersByLineupSetID(importSelect.value);
  }, [importSelect]);

  useEffect(() => {
    props.setReloads(props.reloads + 1);

    const exportedLineupSets = data.exportedLineupSetsForPgaEvent;

    if (!exportedLineupSets || exportedLineupSets.length === 0) {
      setImportSelect({ value: null, label: "No Green Machine Builds" });
    } else {
      setSessionImportOptions(
        exportedLineupSets.map((lineupSet) => {
          return { value: lineupSet.id, label: `Build #${lineupSet.buildNum}` };
        })
      );

      setImportSelect({ value: null, label: "------" });
    }
  }, [props.selectedEventID]);

  useEffect(() => {
    props.updateMyPlayers(
      data.myPlayersForLiveRound.map((player) => {
        return { value: player.id, label: player.fullName };
      }),
      false
    );
  }, [data]);

  return (
    <div className="live-scorecard-filters-container">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="live-scorecard-filters-players">
        My Players
        <Select
          id="sport-select"
          isMulti
          key={props.reloads}
          value={props.myPlayers}
          options={data.playersForLiveRound.map((player) => {
            return { value: player.id, label: player.fullName };
          })}
          onChange={(selected) => props.updateMyPlayers(selected, true)}
        />
      </label>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="live-scorecard-import-gm-players">
        Import GM Players
        <Select
          id="sport-select"
          key={props.reloads}
          value={importSelect}
          options={sessionImportOptions}
          onChange={(selected) => setImportSelect(selected)}
        />
      </label>
      <br />
    </div>
  );
}
